import { List, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

export const BulletList = ({ title, items }) => {
    return (
        <>
            <Typography variant="h5">{title}</Typography>
            <List>
                {Object.entries(items).map(([key, value], index) => (
                    <ListItem key={index} sx={{ alignItems: "flex-start" }}>
                        <ListItemIcon sx={{ minWidth: "20px", mt: "8px" }}>
                            <FiberManualRecordIcon sx={{ fontSize: 10, color: "#000" }} />
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <Typography variant="h6" color="secondary.light">
                                    {key} : {value}
                                </Typography>
                            }
                        />
                    </ListItem>
                ))}
            </List>
        </>
    );
};

export const BulletListNumber = ({ title, items }) => {
    return (
        <>
            {title && <Typography variant="h5">{title}</Typography>}
            <List>
                {items.map((item, index) => (
                    <ListItem key={index} sx={{ alignItems: "flex-start" }}>
                        <ListItemIcon sx={{ minWidth: "20px", mt: "5px",color:"text.primary" }}>
                            {index + 1}
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <Typography variant="body2">
                                    {item?.answer_text}
                                </Typography>
                            }
                        />
                    </ListItem>
                ))}
            </List>
        </>
    );
};